import { apiClient } from "./apiClient";

export const API_APP_BAIVIET_PATH = "app-bai-viet-trang-thai"

export const appBaiVietTrangThaiApi = {
    SelectAll: () => apiClient.get(API_APP_BAIVIET_PATH)
}